/* Settings → Appearance: Light / Dark / System (owner report 2026-10-31: the Mac app stayed dark in daytime with no way
   to change it). The pure part; the screen part is ui/theme.ts, and index.html repeats the first lines of it (in a tiny
   inline script, before anything is drawn) so the right colors show from the very first frame. Tested in
   tests/app/theme.test.ts. */
export type Theme = 'light' | 'dark' | 'system';
/** per device (localStorage): 'light' or 'dark'; nothing stored = System (the default) */
export const THEME_KEY = 'ot_theme';
export const parseTheme = (v: string | null | undefined): Theme => v === 'light' || v === 'dark' ? v : 'system';
/** the colors in use: System follows the device (style.css is dark unless the device asks for light) */
export const effectiveTheme = (t: Theme, deviceLight: boolean): 'light' | 'dark' => t === 'system' ? (deviceLight ? 'light' : 'dark') : t;
/** the PWA title bar / phone status bar color (the page background of each palette, style.css --bg) */
export const THEME_COLOR = {dark: '#120f0c', light: '#faf7f3'} as const;
/** what to store for a choice (null = remove: System) */
export const storedTheme = (t: Theme): string | null => t === 'system' ? null : t;
